<template>
  
  <ContentsProductHighPerformancePageTitle title="Specialty Compound" />

  <section class="section-product-detail-page" >
    <div class="container">
      <div class="page-content">

        <div class="properties-applications-box">
          <ContentsTextWithImage
            title="Properties"
            image-url="/pages/products/high-performance-plastics/spec01.jpg"
            :contents="[
              'Sometimes naturally properties of materials are just don’t fit product requirements. The specialty compound materials combine different based resins from commodity plastics like PP to high performance plastics like PEI with special fillers and additives to get desired properties such as thermally conductive, electrically conductive, anti-static, EMI shielding, wear and friction, tunable dielectric, laser direct structuring, and high modulus ductile. These enhancing performance makes possible for plastics to replace incumbent material like metal or glass. For example, normal plastic is insulation, but we can make it conductive by adding conductive fillers, then we can use plastic instead of metal to reduce weigh, cost while increasing productivity and freely design.',
            ]"
            :is-reverse="true"
            left-width="43.444%"
            right-width="56.252%"
          />
  
          <ContentsTextWithImage
            title="Applications"
            image-url="/pages/products/high-performance-plastics/spec02.jpg"
            :contents="[
              'Use cases are variety depending on effects we want. For example, semiconductor handling, electronics equipment, medical equipment, automotive radar, ADAS components, laptop housing, mobile phone housing, antenna, gears, metal replacements, and much more.',
            ]"
            left-width="43.421%"
            right-width="56.275%"
          />
        </div>

      </div>
    </div>
  </section>

  <section class="section-product-detail-page section-our-partners">
    <div class="container">
      <div class="page-content">

        <ContentsOurPartners
          :partners="[
            {
              name: 'Sabic',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-sabic.jpg',
              }
            },
            {
              name: 'RTP',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/psu-logo03.jpg',
              }
            },
            {
              name: 'Avient',
              image: {
                width: 412,
                height: 217,
                src: '/pages/products/high-performance-plastics/logo-avie.jpg',
              }
            },
          ]"
        />

      </div>
    </div>
  </section>

</template>
<script setup lang="ts">
useHead({
  title: 'Specialty Compound - NAGASE THAILAND Engineering Plastics',
})
</script>

<style scoped>

.properties-applications-box {
  display: flex;
  flex-direction: column;
  row-gap: 60px;
}

.section-our-partners .page-content {
  padding: 48px 0 60px;
}
</style>